import { render, staticRenderFns } from "./CardAction.vue?vue&type=template&id=db810e3e"
import script from "./CardAction.vue?vue&type=script&lang=js"
export * from "./CardAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Picture: require('/srv/app/components/picture/Picture.vue').default,Icon: require('/srv/app/components/icon/Icon.vue').default})
